import React from "react";
import { useInertiaMassRange } from "../../stores/viewerStore";

/** Mass range legend for inertial ellipsoid coloring (blue → red). */
const InertialScale = () => {
  const inertiaMassRange = useInertiaMassRange();

  if (
    !inertiaMassRange ||
    inertiaMassRange[0] === null ||
    inertiaMassRange[1] === null ||
    inertiaMassRange[0] >= inertiaMassRange[1]
  ) {
    return null;
  }

  const [minMass, maxMass] = inertiaMassRange;

  return (
    <div className="mt-2 rounded-lg border border-gray-700 p-2">
      <div className="mb-1 text-sm font-semibold text-gray-300">Inertia mass color scale</div>
      <div className="flex items-center gap-2 text-xs">
        <span className="shrink-0 tabular-nums text-gray-400">{minMass.toPrecision(3)}</span>
        <div
          className="h-3 min-w-[3rem] flex-1 rounded border border-white/15"
          style={{
            background: "linear-gradient(to right, #2196f3, #f44336)",
          }}
        />
        <span className="shrink-0 tabular-nums text-gray-400">{maxMass.toPrecision(3)}</span>
      </div>
      <div className="mt-1 text-xs panel-text-helper">Low mass (blue) to high mass (red)</div>
    </div>
  );
};

export default React.memo(InertialScale);
